export const DiagramAutoLayoutConfig = {
  type: 'tree',
  orientation: 'horizontal'
};
